

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: "sortBy" })
export class SortByPipe implements PipeTransform {
  transform(array: unknown[], orderBy: { asc: boolean, field: string }): unknown[] {
    if (array == null || orderBy.asc == null) {
      return array;
    }

    const newArray = [].concat(array);

    return newArray.sort((a, b) => {
      const order = orderBy.asc ? 1 : -1;

      for (const key of orderBy.field.split(".")) {
        a = a[key] ?? 0;
        b = b[key] ?? 0;
      }

      if (typeof a === "string") {
        return a.localeCompare(b) * order;
      }

      return (a - b) * order;
    });
  }
}
